import React from 'react';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

const ShowContactPerson = ({input: {value, onChange}, handleModalClick, text, intl}) => {
    text = text || intl.formatMessage(messages.contactPersonDescription);

    return (
        <div className="card card-default top-indent">
            <div className="card-block">
                <blockquote className="card-blockquote">
                    <p>{text}</p>
                    <footer>
                        <button type="button" className="btn btn-primary clickable"
                                onClick={handleModalClick}>
                            {intl.formatMessage(messages.contactPersonCreate)}
                        </button>
                    </footer>
                </blockquote>
            </div>
        </div>
    );
};

export default injectIntl(ShowContactPerson);


// WEBPACK FOOTER //
// ./web/src/components/contact-person/ShowContactPerson.jsx